module.exports = __webpack_public_path__ + "img/etiqueta.e10d397e.svg";